export const isAuthenticated = state => !!state.user

export const isManager = state => {
  if (!state.user) {
    return false
  }
  return state.user.isManager
}

export const userId = state => {
  if (!state.user) {
    return null
  }
  return state.user.id
}

export const getCountries = (state, getters) => {
  let countries = state.countries
  return countries
}
export const selectedCountry = state => {
  return state.selectedCountry
}

export const getDepartments = (state, getters) => {
  return state.departments
}

export const selectedDepartment = state => {
  return state.selectedDepartment
}

export const monitoringData = (state, getters) => {
  const formResponses = state.formResponsesData
  let allUsers = state.allUsersData

  if (getters.selectedCountry) {
    allUsers = allUsers.filter(user => user.country === getters.selectedCountry)
  }
  if (getters.selectedDepartment) {
    allUsers = allUsers.filter(user => user.department === getters.selectedDepartment)
  }

  if (!allUsers || !formResponses) {
    return []
  }

  return allUsers.map(user => {
    let userResponse = formResponses.find(response => {
      return response.userId === user.userId
    })
    console.log(`user ${user.userId} rseponse: ${userResponse}`)

    if (!userResponse) {
      console.log('not answered!')
      userResponse = {
        not_answered: true
      }
    }
    return Object.assign({}, user, userResponse)
  })
}



// WEBPACK FOOTER //
// ./src/store/getters.js